export var MenuState;
(function (MenuState) {
    MenuState[MenuState["CLOSED"] = 0] = "CLOSED";
    MenuState[MenuState["COLUMNS_MANAGEMENT"] = 1] = "COLUMNS_MANAGEMENT";
    MenuState[MenuState["FILTERS"] = 2] = "FILTERS";
    MenuState[MenuState["DENSITY"] = 3] = "DENSITY";
})(MenuState || (MenuState = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFibGVUeXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlRhYmxlVHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMkJBLE1BQU0sQ0FBTixJQUFZLFNBS1g7QUFMRCxXQUFZLFNBQVM7SUFDbkIsNkNBQU0sQ0FBQTtJQUNOLHFFQUFrQixDQUFBO0lBQ2xCLCtDQUFPLENBQUE7SUFDUCwrQ0FBTyxDQUFBO0FBQ1QsQ0FBQyxFQUxXLFNBQVMsS0FBVCxTQUFTLFFBS3BCIn0=